import React, { FC, useState, useEffect, useRef } from 'react';
import { appStore } from '@store';
import {
	Title,
	Subtitle,
	Notification,
	Chart,
	Benefits,
	GetMyPlanBlock,
	Support,
	Reviews,
	Footer,
	Header,
	BeforeAfter,
} from './components';
import { useT } from '@hooks';
import * as S from './styled';

interface Props {
	children: React.ReactElement;
}

export const PaywallLayoutWalkingDesign: FC<Props> = props => {
	const { children } = props;
	const { answers } = appStore.surveyStore;
	const { T } = useT();
	const goalWeight = answers.target_weight?.[0]
		? Number(JSON.parse(answers.target_weight?.[0]).value)
		: 0;
	const currentWeight = answers.weight?.[0] ? Number(JSON.parse(answers.weight?.[0]).value) : 0;
	const { walkingDesignV1 } = appStore.paymentStore.settings;
	const walkingDesignV1Payment =
		window.firebaseConfigData &&
		window.firebaseConfigData.walkingDesignV1Payment === 'walkingDesignV1Payment_b';

	return (
		<>
			{walkingDesignV1 && walkingDesignV1Payment ? (
				<S.Container>
					<Header />
					<S.Padding20>
						<Title>{T('payment_text_6_21')}</Title>
						<Subtitle>
							{goalWeight === currentWeight ? T('payment_text_6_2') : T('payment_text_6_1')}
						</Subtitle>
						<Notification />
						<Subtitle align={'center'}>{T('payment_text_6_3')}</Subtitle>
						<Chart />
						{children}
						<GetMyPlanBlock />
						<Benefits />
						<BeforeAfter />
						<S.MarginTop30>
							<Support />
						</S.MarginTop30>
						<S.MarginTop30>
							<Reviews />
						</S.MarginTop30>
					</S.Padding20>
					<Footer />
				</S.Container>
			) : (
				<S.Container>
					<Header />
					<S.Padding20>
						<Title>{T('payment_text_6')}</Title>
						<Subtitle>
							{goalWeight === currentWeight ? T('payment_text_6_2') : T('payment_text_6_1')}
						</Subtitle>
						<Notification />
						<Subtitle align={'center'}>{T('payment_text_6_3')}</Subtitle>
						<Chart />
						<Benefits />
						{children}
						<GetMyPlanBlock />
						<S.MarginTop30>
							<Support />
						</S.MarginTop30>
						<S.MarginTop30>
							<Reviews />
						</S.MarginTop30>
					</S.Padding20>
					<Footer />
				</S.Container>
			)}
		</>
	);
};
